/**
 * Human-readable formatters.
 */

/** Format seconds as `m:ss` or `h:mm:ss`. */
export function fmtDuration(sec: number | null | undefined): string {
  if (typeof sec !== "number" || !isFinite(sec)) return "—";
  const total = Math.max(0, Math.floor(sec));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  return h > 0
    ? `${h}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`
    : `${m}:${String(s).padStart(2, "0")}`;
}

/**
 * Decode tracknames that arrived mojibake'd due to incorrect encoding. A
 * best-effort heuristic; falls back to the original on failure.
 */
export function decodeTrackName(name: string): string {
  try {
    let decoded = name;
    // Strip numeric prefix some music players leave in filenames.
    decoded = decoded.replace(/^[0-9]+_?/, "");
    // Convert common mis-encoded sequences.
    decoded = decoded
      .replace(/Ã¯Â½Â¡/g, "。")
      .replace(/Ã£Â€Â"/g, "—")
      .replace(/Ã£Â€Â€/g, " ")
      .replace(/Ã¢Â€Â™/g, "'")
      .replace(/Ã¢Â€Â¦/g, "…")
      .replace(/Ã¯Â¼Â/g, "—")
      .replace(/Ã¯Â½Â/g, "");
    return decoded;
  } catch {
    return name;
  }
}

/** Normalise a track's lastPlayed to seconds if given in ms. */
export function normalizeLastPlayedSec(v: number | null | undefined): number | null {
  if (v == null) return null;
  return v > 1e12 ? Math.floor(v / 1000) : v;
}

/** Human-readable last-played time for library rows. */
export function fmtLastPlayed(sec: number | null | undefined): string {
  if (sec == null) return "Never played";
  const now = Math.floor(Date.now() / 1000);
  const age = Math.max(0, now - sec);
  if (age < 120) return "Played recently";
  if (age < 3600) return `${Math.floor(age / 60)}m ago`;
  if (age < 86400) return `${Math.floor(age / 3600)}h ago`;
  if (age < 86400 * 60) return `${Math.floor(age / 86400)}d ago`;
  return `${Math.floor(age / (86400 * 30))}mo+ ago`;
}
